export default __webpack_public_path__ + "static/media/pitching.07ea52f9.pdf";